/**
 * scouts.{tenant} subdomain gate.
 *
 * The A&R scout panel is a separate user-tier surface (role='ar' +
 * admin for support/debug). Page tree lives under /scouts/* in the
 * source; router.options.ts strips that prefix so scouts see clean
 * URLs (scouts.{tenant}/profile etc.) matching the labels.* /
 * creator.* convention.
 *
 * Acceptance:
 *   role === 'admin' (support/preview)
 *   role === 'ar'    (the scout tier itself)
 *
 * Everything else gets bounced — unauthenticated visitors land on the
 * tenant's /auth page (sign-in there flips into the post-login
 * redirect in auth.vue which sends scouts back here), wrong-role users
 * land on the bare tenant apex.
 */
export default defineNuxtRouteMiddleware(() => {
    const url = useRequestURL()

    if (!url.hostname.startsWith('scouts.')) return

    // Anchor the strip with `^scouts\.` so a hostname like
    // `scouts.example.com` doesn't accidentally lose a non-prefix
    // `scouts.` match elsewhere in the string. Mirrors the regex
    // 01.tenant.ts uses for the labels/creator strip.
    const STRIP_SCOUTS = /^scouts\./

    const { user } = useAuth()
    if (!user.value) {
        const mainDomain = url.hostname.replace(STRIP_SCOUTS, '')
        const protocol = url.protocol
        const port = url.port ? `:${url.port}` : ''
        return navigateTo(`${protocol}//${mainDomain}${port}/auth`, { external: true })
    }

    const role = user.value.role
    if (role === 'admin' || role === 'ar') return

    const mainDomain = url.hostname.replace(STRIP_SCOUTS, '')
    const protocol = url.protocol
    const port = url.port ? `:${url.port}` : ''
    return navigateTo(`${protocol}//${mainDomain}${port}/`, { external: true })
})
